<template>
  <page class="bg-color">
    <div class="classify bg-color">
      <van-row class="bg-color">
        <van-col :span="6">
          <ul class="slide-left" ref="menuWrapper">
            <li
              class="slide-left-item"
              :class="index === currentIndex ? 'item-active' : ''"
              v-for="(item, index) in slideBarList"
              :key="item.catId"
              :data-index="index"
              @click="selectMenu(item, index)"
            >
              <a href="javascript:;" class="color-33 ft-14">{{
                item.catName
              }}</a>
            </li>
          </ul>
        </van-col>
        <van-col :span="18" class="slide-right" ref="foodsWrapper">
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="finishedText"
            @load="getGoodsDtoList(goodsListId)"
          >
            <ul class="detail-box" ref="area">
              <li
                class="classify-img"
                v-for="(goods, index) in classifyGoodsList"
                @click="toGoodsDetail(goods)"
                :key="index"
              >
                <goodsItem
                  :goodsName="goods.title"
                  :shopPrice="goods.__actPrice || goods.sellPrice"
                  :marketPrice="goods.marketPrice"
                  :actTitleDTOS="goods.actInfos"
                  :picUrl="goods.skuThumb"
                  type="classify"
                ></goodsItem>
              </li>
            </ul>
          </van-list>
        </van-col>
      </van-row>
    </div>
    <activitypopup channel="classify" />
  </page>
</template>
<script>
import activitypopup from "@/components/activitypopup.vue";
import goodsItem from "@/modules/goodsItem";
import { mapGetters } from "vuex";
import { handlerActGoodsPrice } from "../../modules/common";
export default {
  components: {
    activitypopup,
    goodsItem,
  },
  data() {
    return {
      loading: false,
      finished: false,
      finishedText: "",
      currentIndex: 0,
      slideBarList: [],
      isIOS: true,
      classifyGoodsList: [],
      page: 1,
      pageSize: 10,
      goodsListId: null,
    };
  },
  computed: {
    ...mapGetters(["getEmpNo", "getFromUrl", "isFormalEmp"]),
    ccLogParams() {
      return {
        // user_type: this.isFormalEmp,
        user_empNo: this.getEmpNo || "",
        frontPageName: this.getFromUrl,
        page_name: "商品分类",
        form: "H5",
      };
    },
  },
  methods: {
    async getGoodsCategory() {
      try {
        const { data } = await this.$service.getCategoryNew({ exposure: "h5" });
        this.slideBarList = data;
        this.goodsListId = data[0].id;
        this.getGoodsDtoList(data[0].id);
      } catch (err) {
        console.log("err", err);
      }
    },
    getGoodsDtoList(id) {
      if (id) {
        const params = {
          catId: id,
          exposure: "h5",
          fillTypes: ["fill_act"],
          page: this.page,
          pageSize: this.pageSize,
        };
        this.loading = true;
        this.$service.getGoodsDtoList(params).then((res) => {
          if (res.code === 200) {
            const goods = res.data.goodsList;
            this.classifyGoodsList = handlerActGoodsPrice(
              this.classifyGoodsList.concat(goods)
            );
            if (this.classifyGoodsList.length >= res.data.total)
              this.finished = true;
          }
          // else {
          //   console.log('errerrerrerrerrerrerrerrerrerrerrerrerrerrerrerrerrerr');
          //   this.finished = true;
          // }
          this.page++;
          this.loading = false;
          console.log("this.finished111", this.finished);
          if (this.classifyGoodsList.length > 0) {
            this.finishedText = "没有更多了";
          } else {
            this.finishedText = "";
          }
        });
      }
    },
    // 跳转到详情页
    toGoodsDetail(list) {
      this.$constants.submitccLog(
        "partner_mini_page_click",
        "商品分类点击商品",
        {
          ...this.ccLogParams,
          button_name: "进入商品详情",
        }
      );
      this.$router.push({
        name: "goods-detail",
        query: { goodsId: list.skuId },
      });
    },
    selectMenu(item, index) {
      this.$constants.submitccLog(
        "partner_mini_page_click",
        "商品分类点击tab",
        {
          ...this.ccLogParams,
          button_name: item.title,
        }
      );
      this.currentIndex = index;
      this.goodsListId = item.id;
      this.page = 1;
      this.classifyGoodsList = [];
      this.finished = false;
      this.loading = true;
      if (item.id) {
        this.getGoodsDtoList(item.id);
      }
    },
  },
  mounted() {
    this.getGoodsCategory();
  },
};
</script>
<style lang="stylus" scoped>
.classify .slide-left {
  height: calc(100vh - 70px);
  width: 90px;
  background: #fff;
  overflow: auto;
}

.slide-left-item {
  height: 44px;
  text-align: center;
  line-height: 44px;

  a {
    overflow: auto;
    display: block;
    white-space: nowrap;
  }
}

.item-active {
  background: #EFEFF4;
  border-left: 2px solid #FC4C00;
  color: #333333;
  font-size: 14px;
}

.detail-box {
  background: #EFEFF4;
  padding: 0 5px;
  overflow: auto;
}

.detail-box .detail-title {
  color: #333;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  margin: 12px 0;
  width: 100%;
}

.classify-img {
  height: 250px;
  width: 130px;
  margin-right: 7px;
  overflow: hidden;
  float: left;
  background: #FFFFFF;
  border-radius: 8px;
  margin-top: 8px;

  &:nth-child(even) {
    margin-right: 0;
  }
}

.classify .slide-right {
  backgrund: #f66;
  height: 100vh;
  overflow-y: scroll;
  padding-bottom: 100px;
}
</style>
